import { useIntl } from "@leagueplatform/locales";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { Masonry } from "@leagueplatform/masonry";
import { MASONRY } from "common/constants";
import { PageContentWrapper } from "components/page-content-wrapper.component";

export const ScreeningsPage = () => {
  usePageViewAnalytics({ screen_name: "Screenings" });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: "STR_SCREENINGS" }));

  return (
    <PageContentWrapper>
      <Masonry rootNodeId={MASONRY.ROOT_NODE_ID_SCREENINGS} />
    </PageContentWrapper>
  );
};
